/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CompanyPhysicians } from '../models/CompanyPhysicians';
import { request as __request } from '../core/request';

export class PhysicianService {

    /**
     * Get a company physician
     * @returns CompanyPhysicians Company Physicians
     * @throws ApiError
     */
    public static async getCompanyPhysicians({
companyId,
}: {
/** The companyId **/
companyId: number,
}): Promise<CompanyPhysicians> {
        const result = await __request({
            method: 'GET',
            path: `/companies/${companyId}/physician`,
        });
        return result.body;
    }

}